import { useSuspenseQuery } from '@tanstack/react-query'

import { type DcsListRequestQuery } from '@/libs/api/types'

import { getDcsSelectQueryOptions } from '../query-options'

/**
 * Select用の拠点(物流センター)一覧のUseQuery
 */
export const useDcsSelectQuery = (
  tenantKey: string,
  query?: DcsListRequestQuery
) => {
  return useSuspenseQuery({
    ...getDcsSelectQueryOptions(tenantKey, query),
    retry: false
  })
}
